export const LAST_SPACE_COOKIE = 'odo-last-space'

export const ODO_COOKIE_OPTIONS = {
  path: '/',
  sameSite: 'lax',
  secure: true,
  httpOnly: false
} as const
